module.exports = __webpack_public_path__ + "media/start_page6.9866bb8c.mp3";